import { ExternalLink } from "lucide-react";

const URL_RE = /(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(https?:\/\/[^\s)]+)/g;

function renderInline(text, keyPrefix) {
  const out = [];
  let last = 0;
  let m;
  let i = 0;
  const bolded = (s, k) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((part, j) =>
      part.startsWith("**") && part.endsWith("**") ? <strong key={`${k}-b${j}`}>{part.slice(2, -2)}</strong> : part
    );
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) out.push(...bolded(text.slice(last, m.index), `${keyPrefix}-t${i}`));
    const href = m[3] || m[4];
    const label = m[2] || href.replace(/^https?:\/\//, "");
    out.push(
      <a key={`${keyPrefix}-a${i}`} href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 font-semibold text-[#1E3A8A] underline decoration-2 underline-offset-2 dark:text-blue-300">
        {label}<ExternalLink className="h-3 w-3" />
      </a>
    );
    last = m.index + m[0].length;
    i += 1;
  }
  if (last < text.length) out.push(...bolded(text.slice(last), `${keyPrefix}-t${i}`));
  return out;
}

export default function AssistantMessage({ content }) {
  const lines = content.split("\n");
  const blocks = [];
  let list = null;
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    const li = line.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)$/);
    if (li) {
      if (!list) { list = []; blocks.push(list); }
      list.push(<li key={`li-${idx}`}>{renderInline(li[1], `l${idx}`)}</li>);
      return;
    }
    list = null;
    if (line.trim()) blocks.push(<p key={`p-${idx}`}>{renderInline(line, `p${idx}`)}</p>);
  });
  return (
    <div className="space-y-2 text-sm leading-relaxed">
      {blocks.map((b, i) => (Array.isArray(b) ? <ul key={`ul-${i}`} className="list-disc space-y-1 pl-4">{b}</ul> : b))}
    </div>
  );
}
